import React, { useState, useRef } from "react";
import PopperWrapper from "../popperWrapper/popperWrapper";
import "./ColorPicker.scss";
import { handleEnterKeypress } from "../../utils/keyEvents";
import CustomSwatchPicker from "./CustomSwatchPicker";
import { withDefaults } from "../../utils/withDefaults";
import type { RgbaColor } from "../../types/models";

export interface ColorPickerProps {
  color?: RgbaColor;
  onColorChange?: (color: RgbaColor) => void;
  onLastSwatchTabPress?: () => void;
  onFirstSwatchShiftTabPress?: () => void;
}

export default function ColorPicker(incomingProps: ColorPickerProps) {
  const props = withDefaults(incomingProps, colorPickerDefaultProps);

  const [isVisible, setIsVisible] = useState(false);

  const onClick = () => setIsVisible(!isVisible);

  const onKeyPress = (event: React.KeyboardEvent) => {
    handleEnterKeypress(event, onClick);
  };

  const fieldRef = useRef<HTMLDivElement | null>(null);
  const field = (
    <div
      className="swatch"
      style={{
        background: `rgb(${props.color.r}, ${props.color.g}, ${props.color.b})`
      }}
      onClick={onClick}
      onKeyPress={onKeyPress}
      aria-label="Select Color"
      tabIndex={0}
      ref={fieldRef}
    />
  );

  const handleColorChange = (chosenColor: RgbaColor) => {
    props.onColorChange(chosenColor);
    onLastSwatchTabPress();
  };

  const onLastSwatchTabPress = () => {
    props.onLastSwatchTabPress();
    setIsVisible(!isVisible);
  };

  const onFirstSwatchShiftTabPress = () => {
    setIsVisible(!isVisible);
    fieldRef.current?.focus();
  };

  return isVisible ? (
    <PopperWrapper
      reference={field}
      poppedComponent={
        <CustomSwatchPicker
          onChangeComplete={handleColorChange}
          color={props.color}
          onLastSwatchTabPress={onLastSwatchTabPress}
          onFirstSwatchShiftTabPress={onFirstSwatchShiftTabPress}
        />
      }
      placement="bottom-start"
      referenceStyle={{ width: "100%" }}
    />
  ) : (
    field
  );
}

const colorPickerDefaultProps = {
  color: { r: 0, g: 0, b: 0, a: 1 },
  onColorChange: () => {},
  onLastSwatchTabPress: () => {},
  onFirstSwatchShiftTabPress: () => {}
};
